<mat-card appearance="outlined" class="mat-elevation-z2 w-min-25-vw">
  <mat-card-content>

    <img src="/assets/weseth-white.jpg" class="w-25-vw">

    <div fxLayoutAlign="center">
      <a mat-button class="mb-5" color="primary" (click)="this.authService.login()">Login</a>
      <!-- "Submit registration request" commented -->
    <!-- <a mat-button class="mb-5" color="primary" (click)="openCompanyRequestForm()">Submit registration request</a> -->
    </div>
  </mat-card-content>

  <mat-card-actions fxLayoutAlign="center">
    <ng-container *ngIf="isChina">
      <a class="bottom-link" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024060014号-4</a>
    </ng-container>
  </mat-card-actions>

</mat-card>
